import {clone} from 'ramda'
import axios from "axios";
import Cookies from 'js-cookie'
import {getClientInfo, isAlipay, isAlipayMini, isAndroid, isIphone, isWeixin} from "@/lib/util";

class Monitor {
  constructor() {
    this.__bl = window.__bl || {
      _lg(type = 'pv', options) {
      },
      api(api = '', success = true, time = 0, code = '', msg = '') {
      },
      custom(options) {
      }
    }

    this.timeMap = new Map()
  }

  /**
   * 计算接口耗时
   * @param api
   * @param type [start|end]
   * @private
   */
  _time(api = '', type = 'start') {
    if (type === 'start') {
      this.timeMap.set(api, this.timeMap.get(api) || Date.now())
    } else {
      return Date.now() - this.timeMap.get(api)
    }
  }

  /**
   * 自定义上报页面
   * @private
   */
  _lg() {

  }

  /**
   * 自定义上报api
   * @param api
   * @param success
   * @param time
   * @param code
   * @param msg
   */
  api(api = '', success = true, time = 0, code = '', msg = '') {
    if (msg.length < 2048) this.__bl.api(api, success, time, code, msg);
    else this.apiByChunk(api, success, time, code, msg);
  }

  apiByChunk(api = '', success = true, time = 0, code = '', msg = '') {
    const chunk = Math.ceil(msg.length / 2048);
    for (let i = 0; i < chunk; i++) {
      this.__bl.api(api, success, time, code, `chunk${i + 1}:` + msg.slice(i * 2048, (i + 1) * 2048));
    }
  }
}

export const monitor = new Monitor()


/**
 * 统计点击量
 * @param event
 * @private
 */
export const _sum = (event) => {
  __bl && __bl.sum(event);
}

export const _custom = (data) => {
  const custom = clone(data);
  delete custom.version;
  // Log('custom上报的data', custom)
  __bl && __bl.custom(custom);
}

export const _log = (level, msg) => {
  let timestamp = Date.now();
  let version = window.version;
  let uid = Cookies.get('_bl_uid');
  let mobile = getClientInfo(window.navigator.userAgent);
  let platform = getPlatform();
  let net = getNet();

  axios.get(`https://openmonitor.alipay.com/cloudmonitor/put.htm?pid=${encodeURIComponent('iur+qjtqxnc8cbt5lmoitg==')}&container=app&_input_charset=utf-8&t=log&level=${level}&msg=${msg}&platform=${platform}&net=${net}&uid=${uid}&mobile=${mobile}&version=${version}&timestamp=${timestamp}`)
}

function getPlatform() {
  if (isAlipayMini()) return 'alipayMini';
  if (isAlipay()) return 'alipay';
  if (isWeixin()) return 'weixin';
  if (isAndroid()) return 'android';
  if (isIphone()) return 'iphone';
  return 'other';
}

function getNet() {
  return window.navigator && window.navigator.connection && window.navigator.connection.effectiveType;
}



// WEBPACK FOOTER //
// ./src/lib/monitor.js